import "./css/ProjectCard.scss";
import { useState } from "react";
import Card from "react-bootstrap/Card";
import Carousel from "react-bootstrap/Carousel";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import ListGroup from "react-bootstrap/ListGroup";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

function ProjectCard(props) {
  const [showModal, setShowModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleModal = (e) => {
    if (!showModal) {
      setActiveIndex(Number(e.target.getAttribute("data-index")));
    }
    setShowModal(!showModal);
  };

  const handleSelect = (selectedIndex, e) => {
    setActiveIndex(selectedIndex);
  };

  const toggleSingleLine = (e) => {
    e.target.classList.toggle("ProjectCard__text--single-line");
  };

  return (
    <>
      <Card className="ProjectCard d-inline-block">
        {props.project.images &&
          <Carousel interval={showModal ? null : 5000} activeIndex={activeIndex} onSelect={handleSelect}>
            {
              Object.values(props.project.images).map((image, index) =>
                <Carousel.Item key={index}>
                  <Card.Img
                    className="ProjectCard__carousel-image"
                    src={require(`../assets/${image.fileName}`)}
                    onClick={toggleModal}
                    variant="top"
                    data-index={index}
                    alt={image.altText}
                    loading={index === 0 ? "eager" : "lazy"}
                    decoding={index === 0 ? "auto" : "async"} />
                  {image.caption &&
                    <Carousel.Caption
                      className="ProjectCard__carousel-caption ProjectCard__text--single-line"
                      onClick={toggleSingleLine}>
                      {image.caption}
                    </Carousel.Caption>}
                </Carousel.Item>
              )
            }
          </Carousel>}

        <Card.Header className="p-3 d-flex flex-column">
          <Card.Title className="fw-bold">{props.project.name}</Card.Title>
          <Card.Subtitle className="text-muted">{props.project.startDate} - {props.project.endDate}</Card.Subtitle>
          {props.project.url &&
            <Button className="mt-2 ms-auto d-flex align-items-center gap-2" as="a" variant="primary" href={props.project.url} target="_blank" rel="noopener noreferrer">
              <img src="https://img.icons8.com/fluency-systems-regular/20/FFFFFF/external-link.png" alt="External link icon" />
              Show project
            </Button>}
        </Card.Header>

        <Card.Body>
          <Tabs className="mb-3" fill>
            <Tab eventKey="about" title="About">
              {
                Object.values(props.project.description).map((para, index) =>
                  <Card.Text key={index}>
                    {para.heading ?
                      <>
                        <span className="fw-bold">{para.heading}:</span>{' '}
                        <span>{para.text}</span>
                      </>
                      : para.text}
                  </Card.Text>
                )
              }
            </Tab>

            {props.project.features &&
              <Tab eventKey="features" title="Features">
                {props.project.features.caption &&
                  <Card.Text>{props.project.features.caption}</Card.Text>}
                <ListGroup as="ol" variant="flush" numbered>
                  {
                    Object.values(props.project.features.list).map((feature, index) =>
                      <ListGroup.Item key={index} className="d-flex gap-2" as="li">
                        {feature.heading ?
                          <div className="d-flex flex-column">
                            <div className="fw-bold">{feature.heading}</div>
                            <div>{feature.text}</div>
                          </div>
                          : <div>{feature.text}</div>}
                      </ListGroup.Item>
                    )
                  }
                </ListGroup>
              </Tab>}

            {props.project.learnings &&
              <Tab eventKey="learnings" title="Learnings">
                {
                  Object.values(props.project.learnings).map((learning, index) =>
                    <Card.Text key={index}>
                      {learning.heading ?
                        <>
                          <span className="fw-bold">{learning.heading}:</span>{' '}
                          <span>{learning.text}</span>
                        </>
                        : learning.text}
                    </Card.Text>
                  )
                }
              </Tab>}
          </Tabs>
        </Card.Body>
      </Card>

      <CarouselModal images={props.project.images} activeIndex={activeIndex} handleSelect={handleSelect} show={showModal} closeModal={toggleModal} />
    </>
  );
}

function CarouselModal(props) {
  return (
    <Modal
      show={props.show}
      onHide={props.closeModal}
      fullscreen={true}
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header closeButton>
        <span id="contained-modal-title-vcenter">
          {props.images[props.activeIndex].caption}
        </span>
      </Modal.Header>
      <Modal.Body className="p-0 d-flex justify-content-center align-items-center">
        <Carousel className="ProjectCard__carousel-modal" activeIndex={props.activeIndex} onSelect={props.handleSelect} interval={null}>
          {
            Object.values(props.images).map((image, index) =>
              <Carousel.Item key={index} className="ProjectCard__carousel-modal-item">
                <img
                  className="ProjectCard__carousel-modal-item-img"
                  src={require(`../assets/${image.fileName}`)}
                  alt={image.altText} />
              </Carousel.Item>
            )
          }
        </Carousel>
      </Modal.Body>
    </Modal>
  );
}

export default ProjectCard;